module.exports = __webpack_public_path__ + "b5840a84dc1fc44424947f817a83b8ce.svg";